<template>
<v-row class="slide-home ma-0 pa-0" >
  <v-col cols="12" class="pa-0 swiper-pos ">

  <div v-swiper:mySwiper="swiperOptions" class="">
    <div class="swiper-wrapper ">
      <div class="swiper-slide"  v-for="(slide, i) in slides" :key="i" >
                  <v-row
                  class="ma-0 pa-0"
                    align="center"
                    justify="center"
                    @click="goToFromSlider(slide)"
                  >
                    <v-col :style="slide.style" class="ma-0 pa-0">
                      
                      <v-row
                      class="slide-home ma-0 pa-0"
                      align="center"
                      justify="space-around">

                      <v-col class="pa-0" cols="10">
                       <div  :class="[isMobile ? 'display-1' : 'display-2']">{{slide.text}}</div> 
                       <div  :class="[isMobile ? 'title' : 'display-1']" v-html="slide.subtext"></div> 
                      </v-col>

                      </v-row>

                      </v-col>
                  </v-row>
      </div>
    </div>
    <!-- <div class="swiper-pagination "></div> -->
<!--     <div class="swiper-button-next justify-end d-none  d-lg-flex">
            <v-btn 
            class="ma-2 btn-round-border-w  " 
            fab
            outlined
            x-large                            
            color="#fff"

            >
              <v-icon light>mdi-chevron-right</v-icon>
            </v-btn>
    </div>
    <div class="swiper-button-prev d-none  d-lg-flex justify-start">
            <v-btn 
            class="ma-2 btn-round-border-w" 
            fab
            outlined
            x-large                            
            color="#fff"
            >
              <v-icon light>mdi-chevron-left</v-icon>
            </v-btn>
    </div> -->


  </div>    


                <v-sheet
                  color="transparent"
                  class="dwnlayer-slider"
                  width="100%"
                  v-if="$vuetify.breakpoint.smAndUp"
                >
                    <v-row 
                    align="end"
                    justify="space-between"
                    class="full-screen2 ma-0"
                    >
                    
                        <v-col cols="2" sm="4" md="3" lg="3" xl="3" class="bottom-slide pa-0 ml-0" v-if="$vuetify.breakpoint.smAndUp">
                          <p class="white--text text-left ml-3 mb-0">Мобильное приложение:</p> 
                          <v-row align="start" justify="start" class="ml-2 mt-5">
                            <v-col cols="3"  class="cursor-url  pa-0 d-flex justify-start"  >
                              <img src="@/assets/android_play.png" class="social-ico icon-url" @click="gotoExtUrl('https://play.google.com/store/apps/details?id=org.navimind.gagarin')" key="andr"/>
                              <img src="@/assets/apple_appstore.png" class="social-ico icon-url" @click="gotoExtUrl('')" key="ios"/>
                            </v-col>

                          </v-row>
                        </v-col>

                        <v-col cols="2"  class=" pa-0" v-if="$vuetify.breakpoint.xs">
                        </v-col>


                        <v-col cols="2" sm="3" md="3" lg="3" xl="3"  class="bottom-slide sw-pag pa-0">
                          <v-row justify="center" align="start"  class="mx-0 ">
                                  <v-col cols="12" class="pa-0 d-flex justify-center">
                                    <div class="swiper-pagination d-flex justify-center"></div>
                                  </v-col>
                          </v-row>
                          <v-btn 
                          class="mx-2 btn-round-border-w shv-btn pt-0" 
                          fab     
                          outlined                            
                          color="#fff" 
                          @click="$vuetify.goTo('#target-news', {
                                              duration: 600,
                                              offset: 0,
                                              easing: 'easeInOutCubic',
                                            })"
                          >
                            <v-icon size="32" light>mdi-chevron-down</v-icon>
                          </v-btn> 
                        </v-col>
                        <v-col cols="2"  class=" pa-0" v-if="$vuetify.breakpoint.xs">
                        </v-col>
                        <v-col cols="2" sm="4" md="3" lg="3" xl="3" class="bottom-slide pa-0 mr-0" v-if="$vuetify.breakpoint.smAndUp && dataAdmin!==null">
                                <p class="white--text text-right my-0 mr-3">Мы в социальных сетях:</p> 
                                <v-row justify="center" align="center"  class="mr-2 mt-5">
                                  <v-col cols="12" class="pa-0 d-flex justify-end">

                                      <img  v-for="(itemIcon,ii) in dataAdmin.settings.sn"
                                      :key="`isc-`+ii" :src="itemIcon.file" class="social-ico icon-url cursor-url"  @click="gotoSocial(itemIcon.link)"/>

                                  </v-col>
                                </v-row>
                                
                        </v-col>
                    </v-row>
                </v-sheet>


                <v-sheet
                  color="transparent"
                  class="dwnlayer-slider"
                  width="100%"
                  v-if="$vuetify.breakpoint.xs"
                >
                    <v-row 
                    align="end"
                    justify="space-between"
                    class="full-screen2 ma-0"
                    >
                    
                        <v-col cols="2" sm="4" md="3" lg="3" xl="3" class="bottom-slide pa-0 ml-0" v-if="$vuetify.breakpoint.smAndUp">
                          <p class="white--text text-left ml-3 mb-0">Мобильное приложение:</p> 
                          <v-row align="start" justify="start" class="ml-2 mt-5">
                            <v-col cols="3"  class="cursor-url  pa-0 d-flex justify-start"  >
                              <img src="@/assets/android_play.png" class="social-ico icon-url" @click="gotoExtUrl('https://play.google.com/store/apps/details?id=org.navimind.gagarin')" key="andr"/>
                              <img src="@/assets/apple_appstore.png" class="social-ico icon-url" @click="gotoExtUrl('')" key="ios"/>
                            </v-col>

                          </v-row>
                        </v-col>

                        <v-col cols="2"  class=" pa-0" >
                        </v-col>


                        <v-col cols="2" sm="3" md="3" lg="3" xl="3"  class="bottom-slide sw-pag pa-0">
                          <v-row justify="center" align="start"  class="mx-0 ">
                                  <v-col cols="12" class="pa-0 d-flex justify-center">
                                    <div class="swiper-pagination d-flex justify-center"></div>
                                  </v-col>
                          </v-row>
                          <v-btn 
                          class="mx-2 btn-round-border-w shv-btn pt-0" 
                          fab     
                          outlined                            
                          color="#fff" 
                          @click="$vuetify.goTo('#target-news', {
                                              duration: 600,
                                              offset: 0,
                                              easing: 'easeInOutCubic',
                                            })"
                          >
                            <v-icon size="32" light>mdi-chevron-down</v-icon>
                          </v-btn> 
                        </v-col>
                        <v-col cols="2"  class=" pa-0" v-if="$vuetify.breakpoint.xs">
                        </v-col>
                        <v-col cols="2" sm="4" md="3" lg="3" xl="3" class="bottom-slide pa-0 mr-0" v-if="$vuetify.breakpoint.smAndUp && dataAdmin!==null">
                                <p class="white--text text-right my-0 mr-3">Мы в социальных сетях:</p> 
                                <v-row justify="center" align="center"  class="mr-2 mt-5">
                                  <v-col cols="12" class="pa-0 d-flex justify-end">

                                      <img  v-for="(itemIcon,ii) in dataAdmin.settings.sn"
                                      :key="`isc-`+ii" :src="itemIcon.file" class="social-ico icon-url cursor-url"  @click="gotoSocial(itemIcon.link)"/>

                                  </v-col>
                                </v-row>
                                
                        </v-col>
                    </v-row>
                </v-sheet>
  </v-col>
</v-row>  
</template>

<script>
import { Swiper, SwiperSlide, directive } from 'vue-awesome-swiper'
import 'swiper/css/swiper.css'

  export default {
    name: 'carrousel',
      components: {
        Swiper,
        SwiperSlide
        },
  directives: {
    swiper: directive
  },
  data() {
      return {
        classes: [],
        slides: [
          { 
            text:"ВЕСНА 2020",
            subtext:"Новые коллекции уже в магазинах ТРЦ Гагаринский",
            style:{
            color: '#fff',
            backgroundImage: "url("+require('@/assets/slider/slide01.jpg')+")",
            backgroundSize: 'cover',
            backgroundPosition: 'top center'
            }
            },
         
          { 
            text:"LaserLand",
            subtext:"Центр внеземных развлечений",
            style:{
            color: '#fff',
            backgroundImage: "url("+require('@/assets/slider/slide02.jpg')+")",
            backgroundSize: 'cover',
            backgroundPosition: 'top center'
            }
            },
         
          { 
            text:"Рестораны и Кафе",
            subtext:"Разнообразие на любой вкус",
            style:{
            color: '#fff',
            backgroundImage: "url("+require('@/assets/slider/slide03.jpg')+")",
            backgroundSize: 'cover',
            backgroundPosition: 'top center'
            }
            },
          
        ],        
        swiperOptions: {
          spaceBetween: 0,
          centeredSlides: true,
          loop: true,
/*           autoplay: {
            delay: 6000,
            disableOnInteraction: false
          }, */
          pagination: {
            el: '.swiper-pagination',
            clickable: true,
            bulletClass:'my-bullet',
            bulletActiveClass:'my-bullet-active',
          },
/*           navigation: {
            nextEl: '.swiper-button-next',         
            prevEl: '.swiper-button-prev',         
          } */
        },
      socialLinks:[
        {
        title: 'Facebook',
        link: '',
        icon: require('@/assets/smm_fb1.png')
        },
        {
        title: 'Instagramm',
        link: '',
        icon: require('@/assets/smm_insta1.png')
        },
        {
        title: 'Одноклассники',
        link: '',
        icon: require('@/assets/smm_ok1.png')
        },
        {
        title: 'Telegramm',
        link: '',
        icon: require('@/assets/smm_tel1.png')
        },
        {
        title: 'Twitter',
        link: '',
        icon: require('@/assets/smm_tw1.png')
        },
        {
        title: 'Вконтакте',
        link: '',
        icon: require('@/assets/smm_vk1.png')
        },
      ],      
      }
    },
    computed: {
    isDebug:{
      get() {
        return this.$store.state.app.isDebug;
      },
    },
    dataAdmin:{
      get () {
        return this.$store.getters.getDataAdmin;
      },
     
    }, 

      swiper() {
        return this.$refs.mySwiper.swiper
      },
    isMobile: {
      get () {
        return this.$store.state.app.isMobile
      },
      set (val) {
        let vApp = this
        vApp.$store.dispatch('setIsMobile', val)
      }
    },      
    shops: {
      get() {
        return  this.$store.state.shops.shops
      }
    },    
    news: {
      get() {
        return  this.$store.state.news.news
      }
    },
    categories: {
      get() {      
        return this.$store.state.category.categories
      }      
    },
    allPages: {
      get() {
        return this.$store.getters.getAllPages
      }
    },    
    drawerMenuHome: {
      get () {
        let vApp = this;
        return vApp.$store.state.menu.menuh;
      },

    },

    },
    methods:{
      shuffleArray(a) {
          let i, t, j;
          for (i = a.length - 1; i > 0; i -= 1) {
              t = a[i];
              j = Math.floor(Math.random() * (i + 1));
              a[i] = a[j];
              a[j] = t;
          }
          return a;
      },
      goToFromSlider(currSlide){
        const vApp = this
        if(DEBUG) console.log('currSlide :>> ', currSlide)
      switch (currSlide.typeURL) {
        case "object":
          const getShopSlider = vApp.shops.find(fsh => fsh.id === currSlide.idURL)
          if(DEBUG) console.log('getShopSlider :>> ', getShopSlider)
          vApp.$router
            .push({
              path: '/'+vApp.drawerMenuHome[0].url+'/'+getShopSlider.slug.trim(),
            })
            .catch(() => {
              if(DEBUG) console.log("error Select Filter route in Services Category")
            })
          break
        case "news":
          const getNewsSlider = vApp.news.find(fnews => fnews.id === currSlide.idURL)
          if(DEBUG) console.log('getNewsSlider :>> ', getNewsSlider)
          vApp.$router
            .push({
              path: '/'+vApp.drawerMenuHome[4].url+'/'+getNewsSlider.slug.trim(),
            })
            .catch(() => {
              if(DEBUG) console.log("error Select Filter route in Services Category")
            })
          break
        case "page":
          const getPageSlider = vApp.allPages.find(fpage => fpage.id === currSlide.idURL)
          if(DEBUG) console.log('  --------=======||||||||||||||||()>>>>>> getPageSlider :>> ', getPageSlider)
          vApp.$router
            .push({
              path: '/'+getPageSlider.slug.trim(),
            })
            .catch(() => {
              if(DEBUG) console.log("error Select Filter route in Services Category")
            })
          break
        case "":
            if(DEBUG) console.log('ША! Уже никто, никуда, не идет! :>> ')
          break

        default:
          break
      }



      },
      gotoExtUrl(urlSocial){
        if(DEBUG) console.log('urlSocial :>> ', urlSocial);
      //  window.location.href = urlSocial;
        window.location = urlSocial;
      //  window.location.replace(urlSocial);
      },
      gotoSocial(urlSocial){
        if(DEBUG) console.log('urlSocial :>> ', urlSocial);      
        //window.location = urlSocial;
        var win = window.open(urlSocial, '_blank');
        win.focus();         
      },
    hoverOver: function(e) {
        if(DEBUG) console.log('over = ',e);
        this.classes = [ 'bounce-enter-active']
    },
    hoverOut: function() {
        if(DEBUG) console.log('out');
        this.classes = []
    },
    hoverOutTimeout: function() {
        setTimeout(() => { 
        if(DEBUG) console.log('out');
            this.classes = []
      }, 1000);
    },
    },
    mounted() {
      // current swiper instance
          if(DEBUG) console.log('mounted Home = ', this)
    let vApp = this
    this.$nextTick(function () {
      if(DEBUG) console.log('Current Swiper instance object', this.mySwiper)
      if(DEBUG) console.log('vApp.dataAdmin.actual_banners', vApp.dataAdmin.actual_banners)
      vApp.slides = vApp.dataAdmin.actual_banners.map(as=>{
        return  {             
            idURL:as.some_id,
            typeURL:as.type,
            text:"",
            subtext: as.title,
            style:{
            color: '#fff',
            backgroundImage: "url("+as.image+")",
            backgroundSize: 'cover',
            backgroundPosition: 'top center'
            }
            };
      });
vApp.slides = vApp.shuffleArray(vApp.slides);
    });
    //  this.swiper.slideTo(1, 1000, false)
    },
  beforeDestroy: function () {
      let vApp = this;
      if(DEBUG) console.log("Удаляем SWIPER HOME");
      vApp.mySwiper.destroy();
  }    
  }
</script>

<style  >
.swiper-pos{
  position: absolute;
}
.swiper-slider{
  
  height: 100vh;
}
.slide-home{
  width: 100%;
  height: 100vh;
  
}
.fill-height-2{
  height: 88%;
}
.dwnlayer-slider{
  position: absolute;
  bottom: 13px;
  left: 0;
  z-index: 202;
}
.uplayer-slider{
  position: absolute;
  top: 0;
  left: 0;
  z-index: 201;
}
.full-screen{
  width:100%;
  height: 100vh;
}

.arrowl-slider{
width: 70px;
height: 300px;
margin-left: 200px;
margin-top: -132px;
background-image: url('../assets/arr-l-w.svg');
cursor: pointer;
}

.arrowr-slider{
width: 70px;
height: 300px;
margin-right: 200px;
margin-top: -132px;
background-image: url('../assets/arr-r-w.svg');
cursor: pointer;
}

.swiper-button-prev:after, .swiper-button-next:after{
content: none;
}
.swiper-button-prev{
left: 15%;
}
.swiper-button-next{
right: 15%;
}

.social-ico{
  height: 35px;
}
.span-icon{
  width: 35px;
}
.my-bullet{
    width: 10px;
    height: 10px;
    display: inline-block;
    border-radius: 100%;
    background: #000;
    opacity: 0.2;
     margin: 0 4px;
}
.my-bullet-active{
    opacity: 1;
    background: #fff;

}

/* .bottom-slide{
 position: absolute;
 bottom: 8px;
} */

</style>

<style scoped>
 .swiper-pagination-fraction, .swiper-pagination-custom, .swiper-container-horizontal > .swiper-pagination-bullets{
  bottom: 67px;
} 
.sw-pag{
  height: 80px;
}
.shv-btn{
  margin-top: 30px;
}
</style>